require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./12-th-international-conference-on-sandwich-structures-1-12-1-5.json") })
        }
      }, "path---12-th-international-conference-on-sandwich-structures-1-12-1-5");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---12-th-international-conference-on-sandwich-structures-1-12-1-5!./.cache/json/12-th-international-conference-on-sandwich-structures-1-12-1-5.json
// module id = 311
// module chunks = 231608221292675